import React from 'react';
import './Table.css';

function CompletedOrderTable({ data }) {
  if (!data || data.length === 0) {
    return <div>No completed orders to display.</div>;
  }

  return (
    <table
      className="barcode-table"
      border="1"
      cellPadding="8"
      style={{ borderCollapse: 'collapse', marginTop: '1rem' }}
    >
      <thead>
        <tr>
          <th>Status</th>
          <th>QR Code</th>
          <th>Required Quantity</th>
          <th>Successfully Scanned</th>
        </tr>
      </thead>
      <tbody>
        {data.map(({ barcode, quantity, scannedCount, status }) => (
          <tr key={barcode} className={`row-${status}`}>
            <td>
              <div className={`status-container ${status}`}>
                <span className={`status-dot ${status}`} title={`Status: ${status}`} />
                <span className={`badge ${status}`}>{status.replace('-', ' ')}</span>
              </div>
            </td>
            <td>{barcode}</td>
            <td>{quantity}</td>
            <td>{scannedCount}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default CompletedOrderTable;
